import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import React from "react";
import { CourseItem, getCourseList } from "../../API";
import { getCoursePlanWeek } from "API/course";

export interface CourseDetail extends CourseItem {
    date: string;
}

interface CourseContextProps {
    course: CourseDetail;
    basename: string;
    path: string;
}

export const CourseContext = React.createContext<CourseContextProps>({
    course: {} as CourseDetail,
    basename: "",
    path: ""
});

export interface exerciseItem {
    id: string;
    oneAnswer?: string;
    moreAnswer?: any;
    isAnswer: boolean;
}

interface ExerciseContextProps {
    exercise: exerciseItem[];
}

export const ExerciseContext = React.createContext<ExerciseContextProps>({
    exercise: []
});

export const CoursePlanAtom = atomFamily(
    ({ courseNo, courseSeq }: { courseNo: string; courseSeq: string }) => {
        return atom(get => {
            return getCoursePlanWeek({ courseNo, courseSeq });
        });
    },
    (arg1, arg2) => {
        return (
            arg1.courseNo === arg2.courseNo && arg1.courseSeq === arg2.courseSeq
        );
    }
);

export const CourseListAtom = atomFamily(
    ({ courseNo, courseSeq }: { courseNo: string; courseSeq: string }) => {
        return atom(get => {
            return getCourseList(undefined, courseNo, courseSeq);
        });
    },
    (arg1, arg2) => {
        return (
            arg1.courseNo === arg2.courseNo && arg1.courseSeq === arg2.courseSeq
        );
    }
);
